(ns com.github.tamaikisage.arzulari-yogunlashtir.components
  (:require [com.github.tamaikisage.arzulari-yogunlashtir.browser-data :refer [current-route]]
            [reitit.frontend.easy :as rfe]))

(defn link [route-vector]
  (let [[_ {:keys [name label]}] route-vector
        active-route-name (get-in @current-route [:data :name])
        is-active? (= name active-route-name)
        link-vector [:a {:href (rfe/href name)
                         :class (when is-active? "active")} label]]
    (println link-vector)
    link-vector))

(defn navigation-menu [routes]
  (if (empty? routes)
    [:div "No routes"]
    (->> routes
         (map link)
         (interpose [:span.separator])
         (into [:nav.navigation]))))

(defn sihirli-kart [ad resim tanım]
  (let
   [image-url  (:adres resim)
    caption (:metin resim)]
    [:div.sihirli-kart
     [:h4 ad]
     [:img {:src image-url :alt caption}]
     [:div tanım]]))

(defn img-with-caption [adres erişilebilirlik-metin tanım]
  [:figure.img-with-caption
   [:img {:src adres :alt erişilebilirlik-metin}]
   [:figcaption tanım]])

(defn inline-emphasis [content]
  [:span.inline-emphasis content])